<script>
// [NO-OP] Desabilitado na versão customizada - banner nunca é exibido
export default {};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="false" />
</template>
